import React from 'react'
import PropTypes from 'prop-types'

const SortIcon = ({ width, height, title }) => (
  <svg
    title={title}
    xmlns="http://www.w3.org/2000/svg"
    className="SortIcon"
    width={width}
    height={height}
    viewBox="0 0 14 14"
  >
    <path
      fill="currentColor"
      d="M0 10.9375C0 11.4215 0.391016 11.8125 0.875 11.8125H2.3707C2.70703 12.5863 3.47813 13.125 4.375 13.125C5.27187 13.125 6.04297 12.5863 6.3793 11.8125H13.125C13.609 11.8125 14 11.4215 14 10.9375C14 10.4535 13.609 10.0625 13.125 10.0625H6.3793C6.04297 9.28867 5.27187 8.75 4.375 8.75C3.47813 8.75 2.70703 9.28867 2.3707 10.0625H0.875C0.391016 10.0625 0 10.4535 0 10.9375ZM3.5 10.9375C3.5 10.7054 3.59219 10.4829 3.75628 10.3188C3.92038 10.1547 4.14294 10.0625 4.375 10.0625C4.60706 10.0625 4.82962 10.1547 4.99372 10.3188C5.15781 10.4829 5.25 10.7054 5.25 10.9375C5.25 11.1696 5.15781 11.3921 4.99372 11.5562C4.82962 11.7203 4.60706 11.8125 4.375 11.8125C4.14294 11.8125 3.92038 11.7203 3.75628 11.5562C3.59219 11.3921 3.5 11.1696 3.5 10.9375ZM8.75 6.5625C8.75 6.33044 8.84219 6.10788 9.00628 5.94378C9.17038 5.77969 9.39294 5.6875 9.625 5.6875C9.85706 5.6875 10.0796 5.77969 10.2437 5.94378C10.4078 6.10788 10.5 6.33044 10.5 6.5625C10.5 6.79456 10.4078 7.01712 10.2437 7.18122C10.0796 7.34531 9.85706 7.4375 9.625 7.4375C9.39294 7.4375 9.17038 7.34531 9.00628 7.18122C8.84219 7.01712 8.75 6.79456 8.75 6.5625ZM9.625 4.375C8.72812 4.375 7.95703 4.91367 7.6207 5.6875H0.875C0.391016 5.6875 0 6.07852 0 6.5625C0 7.04648 0.391016 7.4375 0.875 7.4375H7.6207C7.95703 8.21133 8.72812 8.75 9.625 8.75C10.5219 8.75 11.293 8.21133 11.6293 7.4375H13.125C13.609 7.4375 14 7.04648 14 6.5625C14 6.07852 13.609 5.6875 13.125 5.6875H11.6293C11.293 4.91367 10.5219 4.375 9.625 4.375ZM5.25 3.0625C5.01794 3.0625 4.79538 2.97031 4.63128 2.80622C4.46719 2.64212 4.375 2.41956 4.375 2.1875C4.375 1.95544 4.46719 1.73288 4.63128 1.56878C4.79538 1.40469 5.01794 1.3125 5.25 1.3125C5.48206 1.3125 5.70462 1.40469 5.86872 1.56878C6.03281 1.73288 6.125 1.95544 6.125 2.1875C6.125 2.41956 6.03281 2.64212 5.86872 2.80622C5.70462 2.97031 5.48206 3.0625 5.25 3.0625ZM7.2543 1.3125C6.91797 0.538672 6.14687 0 5.25 0C4.35313 0 3.58203 0.538672 3.2457 1.3125H0.875C0.391016 1.3125 0 1.70352 0 2.1875C0 2.67148 0.391016 3.0625 0.875 3.0625H3.2457C3.58203 3.83633 4.35313 4.375 5.25 4.375C6.14687 4.375 6.91797 3.83633 7.2543 3.0625H13.125C13.609 3.0625 14 2.67148 14 2.1875C14 1.70352 13.609 1.3125 13.125 1.3125H7.2543Z"
    />
  </svg>
)

SortIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
}

SortIcon.defaultProps = {
  width: 14,
  height: 14,
  title: 'Sort',
}

export default SortIcon
